import { ButtonBase, CardMedia } from '@mui/material';
import './DrinksCard.scss';

interface DrinkCardProps {
  title: string;
  description: string;
  image?: string;
  price: string;
  onClick?: () => void;
}

const DrinkCard = ({
  title,
  price,
  image,
  onClick,
}: DrinkCardProps) => {
  return (
    <ButtonBase
      className="drink drink--catalog-card"
      onClick={onClick}
      component="div"
      sx={{ alignItems: 'flex-start' }}
    >
      <div className="drink__body">
        <div className="drink__body-header">
          {image ? (
            <CardMedia
              className="drink__image"
              component={'img'}
              title={title}
              image={image}
            />
          ) : null}
          <h3 className="drink__title">{title}</h3>
          <p className="drink__price">{price}</p>
        </div>
      </div>
    </ButtonBase>
  );
};

export default DrinkCard;
